<template>
  <div class="h-[40px] flex items-center gap-[5px]">
    <b-spinner
      v-if="data.isLoading"
      variant="primary"
      small
    />
    <div v-else>
      {{ data.cost | rupiah }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'WithdrawalFeeCell',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({
        isLoading: false,
        cost: 0,
      }),
    },
  },
}
</script>
